import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { MDBCardHeader } from "mdbreact";
import { SetSelectedAppointment } from "../../../../services/redux/slices/diagnostics/clinic/clinicalBilling";
import { buildAppointmentOptions } from "./utils";

export default function BillingHeader() {
  const dispatch = useDispatch();
  const { collections = [], selectedAppointmentId = "" } = useSelector(
    ({ clinicalBilling }) => clinicalBilling,
  );
  const appointmentOptions = buildAppointmentOptions(collections);

  return (
    <MDBCardHeader className="d-flex flex-wrap align-items-center justify-content-between">
      <div>
        <strong>Consultation Billing</strong>
        <div className="small text-muted">
          Secretary billing for confirmed appointments under tagged physicians.
        </div>
      </div>

      <div style={{ minWidth: "24rem", maxWidth: "100%" }}>
        <select
          className="form-control"
          value={selectedAppointmentId || ""}
          onChange={({ target }) =>
            dispatch(SetSelectedAppointment(target.value))
          }
        >
          <option value="">Select confirmed appointment</option>
          {appointmentOptions.length === 0 && (
            <option value="" disabled>
              No confirmed appointments available
            </option>
          )}
          {appointmentOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </MDBCardHeader>
  );
}
